export default __webpack_public_path__ + "static/media/dtsu5168_ct_gw214.82392f07.png";